import { AnimatePresence, motion, useReducedMotion } from 'framer-motion'
import PropTypes from 'prop-types'
import { useEffect, useState } from 'react'

import { DURATION, EASE } from './tokens'

// Zeigt erst `from` und klappt nach `delay` Sekunden auf `to` um: der alte Wert
// gleitet nach oben weg, der neue kommt von unten. Für sichtbare Upgrades wie
// „Regelstand 1 → 3“. Bei reduzierter Bewegung steht sofort `to` da.
const ValueFlip = ({ from, to, delay, className }) => {
  const reducedMotion = useReducedMotion()
  const [current, setCurrent] = useState(reducedMotion ? to : from)

  useEffect(() => {
    if (reducedMotion) {
      setCurrent(to)
      return undefined
    }
    setCurrent(from)
    const timer = setTimeout(() => setCurrent(to), delay * 1000)
    return () => clearTimeout(timer)
  }, [from, to, delay, reducedMotion])

  return (
    <span className={`relative inline-flex overflow-hidden ${className || ''}`}>
      <AnimatePresence mode='popLayout' initial={false}>
        <motion.span
          key={String(current)}
          className='inline-block'
          initial={{ y: '100%', opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: '-100%', opacity: 0 }}
          transition={{ duration: DURATION.slow, ease: EASE.standard }}
        >
          {current}
        </motion.span>
      </AnimatePresence>
    </span>
  )
}

ValueFlip.propTypes = {
  from: PropTypes.node.isRequired,
  to: PropTypes.node.isRequired,
  delay: PropTypes.number,
  className: PropTypes.string
}

ValueFlip.defaultProps = {
  delay: 0.9,
  className: undefined
}

export default ValueFlip
